import React from 'react'
import PropTypes from 'prop-types'

import FormHeader from 'components/Cognito/Shared/FormHeader'

export function FormPage({ title = '', subtitle = '', className = '', children }) {
  return (
    <div className={`form-page ${className}`}>
      <FormHeader title={title} subtitle={subtitle} />
      <div className="form-wrapper">{children}</div>
    </div>
  )
}

FormPage.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
}
